import type { Plugin } from 'vue';
import EventBus, { type EventBusInterface } from '@/services/eventbus/EventBus';

export default {
    install: (app) => {
        const eventbus: EventBusInterface = EventBus.getInstance();
        app.provide('eventbus', eventbus);
        // eslint-disable-next-line no-param-reassign
        app.config.globalProperties.$eventBus = eventbus;
    },
} as unknown as Plugin;
